import { NavLink } from "react-router-dom";
import { CheckCheck } from "lucide-react";
import { useT } from "../../../../i18n/I18nProvider";
import { Avatar, Card, CardHead, EmptyState, StatusPill } from "../../../ui";
import type { DashAttentionItem } from "../../../../lib/dashboard";

/**
 * The one panel that is a to-do list rather than a report.
 *
 * Sorted by how late each thing is, not by type: an invoice five days overdue
 * and a ticket nobody answered are the same problem to whoever is reading this,
 * and grouping them by table would bury the urgent one under a heading.
 */
export function AttentionCard({ attention }: { attention: DashAttentionItem[] }) {
  const t = useT();

  const age = (days: number | null) => {
    if (days === null) return "";
    return days < 0 ? t("dash.attention.late", { n: Math.abs(days) }) : t("dash.attention.left", { n: days });
  };

  return (
    <Card>
      <CardHead title={t("dash.attention.title")} sub={t("dash.attention.sub", { n: attention.length })} />
      {attention.length === 0 ? (
        <EmptyState icon={CheckCheck} title={t("dash.attention.emptyTitle")} body={t("dash.attention.emptyBody")} />
      ) : (
        <div className="crm-rows">
          {attention.map((row) => (
            <NavLink key={row.key} to={row.to} className="crm-prow">
              <Avatar name={row.name} size={36} />
              <span className="min-w-0 flex-1">
                <span className="crm-prow-n crm-trunc block">{row.name}</span>
                <span className="crm-prow-s crm-trunc block">
                  {t(`dash.attention.kind.${row.kind}`)} &middot; {row.what}
                </span>
              </span>
              <StatusPill tone={row.tone}>{age(row.days)}</StatusPill>
            </NavLink>
          ))}
        </div>
      )}
    </Card>
  );
}
